import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { InputEmailFormik } from '@/general/components/forms/Input/InputEmailFormik';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import { EmailFormValidation, EmailFormValues, PersonalizedQuoteFormProps } from './PersonalizedQuoteForm.type';

const initialValues: EmailFormValues = {
  email: '',
};

export const EmailForm: FC<PersonalizedQuoteFormProps<EmailFormValues>> = ({ onSubmit, onBack, values }) => (
  <>
    <CheckoutDescription title={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_EMAIL_FORM_HEADER)} onBack={onBack} />
    <div className={styles.emailForm}>
      <Formik
        initialValues={{ ...initialValues, ...values }}
        validateOnChange={false}
        onSubmit={onSubmit}
        validationSchema={EmailFormValidation}
      >
        {(props) => (
          <Form className={styles.form}>
            <InputEmailFormik id="email" name="email" label="Email address" disabled={props.isSubmitting} />
            <footer className={styles.footer}>
              <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_EMAIL_FORM_CTA)}
              </Button>
            </footer>
            <div className={styles.notice}>
              {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_EMAIL_FORM_DESCRIPTION, true)}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  </>
);
